import ko from 'knockout';

export default class ViewModel {
  constructor() {
    this.hasData = ko.observable(false);
    this.loaded = ko.observable(false);
    this.hasChanges = ko.observable(false);
  }
}
